// src/modules/competition/components/CompetitorsTable/index.js
import React from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';
import CompetitorsTableBody from './CompetitorsTableBody';
import './styles.css';

const CompetitorsTable = ({ competitors, lowestCompetitor, pointTarget, onUsernameClick }) => {
    return (
        <div className="competitors-table-wrapper">
            <Table striped hover responsive>
                <thead>
                    <tr>
                        <th style={{ width: '30%' }}>Name</th>
                        <th style={{ width: '20%' }}>Total Points</th>
                        <th style={{ width: '20%' }}>Number of Activities</th>
                        <th style={{ width: '30%' }}>Cake Progress</th>
                    </tr>
                </thead>
                <CompetitorsTableBody
                    competitors={competitors}
                    lowestCompetitor={lowestCompetitor}
                    pointTarget={pointTarget}
                    onUsernameClick={onUsernameClick}
                />
            </Table>
        </div>
    );
};

CompetitorsTable.propTypes = {
    competitors: PropTypes.arrayOf(PropTypes.shape({
        username: PropTypes.string.isRequired,
        firstName: PropTypes.string.isRequired,
        totalPoints: PropTypes.number.isRequired,
        numActivities: PropTypes.number.isRequired
    })).isRequired,
    lowestCompetitor: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        profilePicture: PropTypes.string,
        totalPoints: PropTypes.number.isRequired
    }),
    pointTarget: PropTypes.number.isRequired,
    onUsernameClick: PropTypes.func.isRequired
};

export default CompetitorsTable;
